import { $getRequestHistory, getRequestHistory } from './actionCreators';
import reducer from './reducer';
import sagas from './sagas';

export default {
  sagas,
  reducer,
  actions: {
    getRequestHistory,
  },
};

export const $actions = {
  getRequestHistory: $getRequestHistory,
};
